import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.error.cause.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-245d0d25"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "联系人名称", -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "手机号码/座机号", -1));

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 客服信息(1) ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 客服信息(2) ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("保存");

import { computed, ref, watch } from 'vue';
import { getCusServiceInfo, saveCusServiceInfo } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'setCusServiceModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const form = ref({
      name0: '',
      customerId0: undefined,
      phone0: '',
      name1: '',
      customerId1: undefined,
      phone1: ''
    });
    const formRef = ref();
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        getCusServiceInfo().then(data => {
          if (data.success) {
            const [row0, row1] = data.rows;
            form.value.name0 = row0.name;
            form.value.customerId0 = row0.customerId;
            form.value.phone0 = row0.phone;
            form.value.name1 = row1.name;
            form.value.customerId1 = row1.customerId;
            form.value.phone1 = row1.phone;
          }
        });
      }
    });

    function validPhone(rule, val, cb) {
      if (!/^[0-9]{8,11}$/.test(val)) {
        cb(new Error());
        return;
      }

      cb();
    }

    function confirm() {
      formRef.value.validate(e => {
        if (e) {
          saveCusServiceInfo(_objectSpread(_objectSpread({}, form.value), {}, {
            __warn: true,
            __repeat: true
          })).then(data => {
            if (data.success) {
              visible.value = false;
              ElMessage.success('操作成功!');
            }
          });
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "客服信息维护",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form, {
          model: form.value,
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 6
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.name0,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name0 = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.phone0,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.phone0 = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 6
            }, {
              default: _withCtx(() => [_hoisted_4]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.name1,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.name1 = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.phone1,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.phone1 = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};